angular.module('dpw.components')
    .filter('dpwUpperCaseStudyContent', function () {
        return function (raw) {
            // ['industry-Professional_services'] => 'Professional Service'
            // ['company-Mid-Sized'] => 'Mid-Sized'
            var value = _.first(raw) || '';
            var stringAfterFirstHyphen = value.substr(value.indexOf('-') + 1);

            return _.capitalize(stringAfterFirstHyphen.split('_').join(' '));
        };
    })
    .directive('dpwCaseStudySlider', [function () {
        return {
            restrict: 'A',
            scope: {
                title: '@?',
                titleTag: '@?',
                subtitle: '@?',
                subtitleTag: '@?',
                studies: '=?'
            },
            bindToController: true,
            controllerAs: 'ctrl',
            controller: [function () {
                this.title = this.title || 'Case studies';
                this.titleTag = this.titleTag || 'h2';
                this.studies = this.studies || RCDPW.Lang.CaseStudies.items;
            }],
            templateUrl: 'dpw-case-study-slider.html'
        };
    }]);
